import {
  createFulfillmentFingerprint,
  normalizeFulfillmentContext,
} from "./fulfillmentContext";

const compact = (value) =>
  Object.keys(value || {}).reduce((result, key) => {
    if (value[key] !== undefined && typeof value[key] !== "function")
      result[key] = value[key];
    return result;
  }, {});

export const buildCheckoutPayload = ({
  address = {},
  contact = {},
  cart = {},
  branch = {},
  promise = {},
  deliveryTime = {},
  checkout = {},
  settings = {},
  metadata = {},
} = {}) => {
  const fulfillmentContext = normalizeFulfillmentContext({
    address,
    branch,
    deliveryTime,
    settings,
  });

  return compact({
    ...compact(address),
    ...compact(contact),
    ...compact(cart),
    ...compact(checkout),
    ...compact(branch),
    ...compact(promise),
    expected_delivery_date: fulfillmentContext.time.date,
    expected_delivery_slot_start: fulfillmentContext.time.start,
    expected_delivery_slot_end: fulfillmentContext.time.end,
    is_asap: fulfillmentContext.time.type === "asap",
    asap_authority:
      fulfillmentContext.time.type === "asap"
        ? fulfillmentContext.time.authority || null
        : null,
    fulfillment_context_version: fulfillmentContext.version,
    fulfillment_context_fingerprint:
      createFulfillmentFingerprint(fulfillmentContext),
    ...compact(metadata),
  });
};

export const buildTrackingPaymentPayload = ({
  order,
  payment = {},
  state = {},
} = {}) =>
  compact({
    ...compact(payment),
    cart: [],
    promo_items: [],
    dine_in_order_id: order?.tracking_id,
    isPayment: true,
    tip:
      state.selectedTip === "Custom"
        ? Number(state.customTip || 0)
        : state.selectedTip || 0,
  });

export const getSafePaymentAttempt = (response = {}, now = Date.now()) => {
  const trackingId = `${
    response.tracking_id || response.trackingId || response.promise?.tracking_id || ""
  }`.trim();
  if (!trackingId) return null;
  const hasRedirect =
    !!response.paymentURL &&
    response.paymentURL !== "Invalid" &&
    response.paymentURL !== -1;
  const explicitPaymentStatus = `${
    response.payment_status || response.paymentStatus || ""
  }`.trim().toLowerCase();
  const paymentWasConfirmed =
    response.payment_complete === true ||
    response.paymentComplete === true ||
    ["paid", "success", "succeeded", "complete", "completed"].includes(
      explicitPaymentStatus,
    );

  return {
    attemptId: trackingId,
    trackingId,
    method: `${response.method || response.payment_method || ""}`.trim(),
    status: hasRedirect
      ? "redirected"
      : paymentWasConfirmed
        ? "succeeded"
        : "pending",
    createdAt: now,
    updatedAt: now,
    errorCode: null,
    returnPath: "/checkout",
  };
};
